var render = function render(){var _vm=this,_c=_vm._self._c;return _c('acclaro-datatable',{attrs:{"grid-title":"All Review Tasks","search-route":"/datatables/tasks","search-placeholder":"Filter Review Tasks...","datatable-name":"allreviewtasks","no-results":'No review tasks found',"options":{
    sortable: [
    'Task Name', 'Order', 'Order ID', 'Language',
    'Review Status', 'Assigned', 'Assigned By',
    'Assigned to', 'Task Due', 'Order Due'
    ],
    perPage: 20
  },"column-templates":_vm.templates},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('create-order-btn')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }